export default __webpack_public_path__ + "static/media/truck-loaded-dark.30df6eb1.png";